export const SET_TRACKS = "SET_TRACKS";
export const SET_FAVORITE_TRACKS = "SET_FAVORITE_TRACKS";
export const SET_ALL_FAVORITES = "SET_ALL_FAVORITES";
export const SET_PLAY = "SET_PLAY";
export const SET_FILTER_IPUNT = "SET_FILTER_IPUNT";
export const SET_FILTER_SELECT = "SET_FILTER_SELECT";
export const SET_ACTIVE_ROUTER = "SET_ACTIVE_ROUTER";
